import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { LogonSvg } from './LogonSvg'

export const EaLogonIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={LogonSvg} {...props} />
)
